import React from 'react';
import { cn } from '../../lib/utils';

interface CirculerShadowProps {
  className?: string;
}

const CirculerShadow = ({ className }: CirculerShadowProps) => {
  return (
    <div
      className={cn(
        'h-[538px] w-[538px] inset-[-10px] bg-gradient-to-r from-[#F4EBFECC] to-[#f4ebfedd] via-[#F4EBFECC] blur-[80px] rounded-full pointer-events-none -z-10',
        className,
      )}
    />
  );
};

export default CirculerShadow;
